<template>
<div>
    <slot name="filters"></slot>
    <div class="nj-buttons">
        <slot name="buttons"></slot>
    </div>
</div>
</template>

<script>

export default {
    name: "Filters",
}
</script>

<style scoped>
.line {
    width: 100%;
    height: 1px;
    border-top: 1px solid #ccc;
    margin-bottom: 8px;
}
</style>